"use client";

import { useUserAuthDataContext } from "@/global-context/user-auth-context";
import { UserData } from "@/types/types";
import { useEffect } from "react";

export default function AuthDataManager({
  children,
  newUserData,
}: {
  children: React.ReactNode;
  newUserData: UserData;
}) {
  const { setUserData } = useUserAuthDataContext();
  useEffect(() => {
    setUserData(newUserData);
  }, [newUserData, setUserData]);
  return <>{children}</>;
}
